import React, { Component } from "react";
import styled from "styled-components";

import Dialog from "./Dialog";
import { Button } from "../../design-system";

const FixedContainer = styled.div`
  position: fixed;
  top: calc(104px + var(--space-3));
  right: var(--space-5);
  z-index: 1300;
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
`;

const SaveIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
    <polyline points="17 21 17 13 7 13 7 21" />
    <polyline points="7 3 7 8 15 8" />
  </svg>
);

const EditIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
  </svg>
);

const TrashIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
  </svg>
);

type Props = {
  onChageFormToEditMode?: Function;
  onRemoveItem?: Function;
  canBeRemoved?: boolean;
  onClick: Function;
  disabled: boolean;
  entity?: string;
  mode: string;
  hidden?: boolean;
};

type State = {
  isRemoveDialogOpen: boolean;
};

class ActionFormButton extends Component<Props, State> {
  state = {
    isRemoveDialogOpen: false,
  };

  onToggleRemoveDialog = (): void => {
    const { isRemoveDialogOpen } = this.state;
    this.setState({ isRemoveDialogOpen: !isRemoveDialogOpen });
  };

  renderSaveButton = (mode: string): React.ReactNode => {
    const { onClick, disabled } = this.props;

    const label = mode === "create" ? "Save" : "Save changes";

    return (
      <Button
        variant="primary"
        size="md"
        iconLeft={<SaveIcon />}
        type="submit"
        disabled={disabled}
        onClick={(event) => {
          event.preventDefault();
          onClick();
        }}
      >
        {label}
      </Button>
    );
  };

  renderDetailActions = (): React.ReactNode => {
    const { onChageFormToEditMode, canBeRemoved } = this.props;
    return (
      <>
        {canBeRemoved && (
          <Button
            variant="ghost"
            size="md"
            iconLeft={<TrashIcon />}
            onClick={() => this.onToggleRemoveDialog()}
          >
            Delete
          </Button>
        )}
        <Button
          variant="primary"
          size="md"
          iconLeft={<EditIcon />}
          onClick={() => onChageFormToEditMode && onChageFormToEditMode()}
        >
          Edit
        </Button>
      </>
    );
  };

  renderRemoveDialog = (): React.ReactNode => {
    const { isRemoveDialogOpen } = this.state;
    const { onRemoveItem, entity } = this.props;

    return (
      <Dialog
        description={`Si realizas esta acción, los datos de este ${entity} serán eliminados, y no se podrán recuperar de ninguna manera.`}
        title={`Estás seguro que quieres eliminar este ${entity}?`}
        positiveAction={() => onRemoveItem && onRemoveItem()}
        negativeAction={this.onToggleRemoveDialog}
        onCloseDialog={this.onToggleRemoveDialog}
        isOpen={isRemoveDialogOpen}
        positiveText="YES"
        negativeText="NO"
      />
    );
  };

  render() {
    const { mode, hidden } = this.props;

    if (hidden) return null;

    return (
      <FixedContainer>
        {mode === "detail" ? this.renderDetailActions() : this.renderSaveButton(mode)}
        {this.renderRemoveDialog()}
      </FixedContainer>
    );
  }
}

export default ActionFormButton;
